import { browserHistory } from "react-router";

export const onEnterPressed = (e, value, action) => {
  if (e.key === "Enter") {
    return action(value);
  }
  return null;
};

export const isShiftPressed = (e) => {
  if (e.key === "Shift") {
    return true;
  }
  return false;
};

export const onHeaderSearch = (e, value, action, selectedAccount, location) => {
  if (e.key === "Enter") {
    if (location.pathname === `/accounts/${selectedAccount.slug}/documents/all`) {
      return action(value);
    }
    browserHistory.push(`/accounts/${selectedAccount.slug}/documents/all`);
    return action(value);
  }
  return null;
};



// WEBPACK FOOTER //
// ./src/js/utils/key-press.js